// src/components/common/ErrorDisplay

import React from 'react'
import { useSelector } from 'react-redux'
import { AppState } from '../store/redux/types'
import { clearError, ErrorState } from '../store/redux/slices/errorSlice'
import { useAppDispatch } from '../hooks/reduxHooks'
import { IonAlert } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

const ErrorDisplay: React.FC = () => {
  const { title, message, isVisible } = useSelector((state: AppState): ErrorState => state.error)
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const history = useHistory()

  const isAccountNotActivated = message === t('login.accountNotActivated')

  const buttons = isAccountNotActivated
    ? [
        {
          text: t('btn.createAccount'),
          handler: () => {
            dispatch(clearError())
            history.replace('/signup')
          },
        },
        {
          text: t('btn.close'),
          handler: () => dispatch(clearError()),
        },
      ]
    : [
        {
          text: t('btn.close'),
          handler: () => dispatch(clearError()),
        },
      ]

  return (
    <IonAlert
      isOpen={isVisible}
      onDidDismiss={() => dispatch(clearError())}
      header={title}
      message={message}
      buttons={buttons}
    />
  )
}

export default ErrorDisplay
